// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1X74A","name":"Header_name__2gk4S","birthday":"Header_birthday__1_Os8","skeleton":"Header_skeleton__1-X_A"};